import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import { CopySVG, CheckSVG } from '../components/Icon/Icon';

export function useCopyCodeBlock() {
  useEffect(() => {
    document.querySelectorAll("pre[class*='language-']").forEach((block) => {
      if (block.querySelector('.copy-button')) return;

      const button = document.createElement('button');
      button.className = 'copy-button';
      button.setAttribute('data-state', 'copy');

      ReactDOM.render(<CopySVG />, button);

      button.addEventListener('click', () => {
        const code = block.querySelector('code').innerText;
        navigator.clipboard.writeText(code).then(() => {
          button.setAttribute('data-state', 'check');
          ReactDOM.render(<CheckSVG />, button);

          setTimeout(() => {
            button.setAttribute('data-state', 'copy');
            ReactDOM.render(<CopySVG />, button);
          }, 1500);
        });
      });

      block.appendChild(button);
    });
  }, []);
}
